import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Density = 'compact' | 'comfortable' | 'spacious';

export interface PreferencesState {
  /** Hides secondary panels / non-essential dashboard cards */
  focusMode: boolean;
  /** Controls padding/spacing throughout the admin UI */
  density: Density;
  /** Disables CSS transitions and animations app-wide */
  reduceMotion: boolean;
  /** Last admin route visited so the dashboard can show "Continue where you left off" */
  lastVisitedRoute: string | null;
  /** Last calendar view mode used (day, week, or month) */
  lastCalendarView: 'day' | 'week' | 'month';
  /** Last reschedule form mode used in appointment detail modal (manual entry or slots picker) */
  lastRescheduleMode: 'manual' | 'slots';

  setFocusMode: (enabled: boolean) => void;
  setDensity: (density: Density) => void;
  setReduceMotion: (enabled: boolean) => void;
  setLastVisitedRoute: (route: string) => void;
  setLastCalendarView: (view: 'day' | 'week' | 'month') => void;
  setLastRescheduleMode: (mode: 'manual' | 'slots') => void;
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      focusMode: false,
      density: 'comfortable',
      reduceMotion: false,
      lastVisitedRoute: null,
      lastCalendarView: 'day',
      lastRescheduleMode: 'manual',

      setFocusMode: (enabled) => set({ focusMode: enabled }),
      setDensity: (density) => set({ density }),
      setReduceMotion: (enabled) => set({ reduceMotion: enabled }),
      setLastVisitedRoute: (route) => set({ lastVisitedRoute: route }),
      setLastCalendarView: (view) => set({ lastCalendarView: view }),
      setLastRescheduleMode: (mode) => set({ lastRescheduleMode: mode }),
    }),
    { name: 'tilly-preferences' }
  )
);
